export default {
    //个人信息
    getMemberInfo (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/user',{params:params})
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //修改个人信息
    updateInfo (params) {
        return new Promise((resolve, reject) => {
            axios.put('/api/user',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //上传图片
    uploadImg (params) {
        return new Promise((resolve, reject) => {
            axios.post('/api/upload',params,{
                headers:{'Content-Type':'multipart/form-data'}
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    Login(params){
        return new Promise((resolve, reject) => {
            axios.post('/api/user/login',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    getCode(params){
        return new Promise((resolve, reject) => {
            axios.post('/api/sms/code',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    getMyFollow(params){
       return new Promise((resolve, reject) => {
        axios.get('/api/my/follow',{params:params})
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
   },
   getMyFans(params){
       return new Promise((resolve, reject) => {
        axios.get('/api/my/fans',{params:params})
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
   },
   getMyInfo(id,params){
       return new Promise((resolve, reject) => {
        axios.get('/api/user/'+id,{params,params})
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
   },
   getSpaceList(params,user_id){
     return new Promise((resolve, reject) => {
        axios.get('/api/space/'+user_id+'/lists',{params:params})
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
 },
 getHonor(params){
     return new Promise((resolve, reject) => {
        axios.get('/my/honor',{params:params})
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
 },
 getMyGrade(params){
   return new Promise((resolve, reject) => {
    axios.get('/api/my/level',params)
    .then((response) => {
        resolve(response)
    })
}, err => {
    reject(err)
})
},
getGradeInfo(params){
   return new Promise((resolve, reject) => {
    axios.get('/api/my/level-intro',params)
    .then((response) => {
        resolve(response)
    })
}, err => {
    reject(err)
})
},
boundMobile(params){
   return new Promise((resolve, reject) => {
    axios.post('/api/user/phone_binding',params)
    .then((response) => {
        resolve(response)
    })
}, err => {
    reject(err)
})
},
userOther(params){
   return new Promise((resolve, reject) => {
    axios.get('/api/user-other',{params:params})
    .then((response) => {
        resolve(response)
    })
}, err => {
    reject(err)
})
},
getImgList(params){
   return new Promise((resolve, reject) => {
    axios.get('/api/huodong/recruit-code',{params:params})
    .then((response) => {
        resolve(response)
    })
}, err => {
    reject(err)
})
},
}